// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    UNITTYPES_CREATE_REQUEST,
    UNITTYPES_UPDATE_REQUEST,
    UNITTYPES_GET_REQUEST,
} from 'Redux/actionTypes';

// Actions
import {
    unitTypeCreateResult,
    unitTypeGetResult,
    unitTypeUpdateResult,
} from 'Redux/actions';

// Helpers
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* createUnitType({ payload }) {
    try {

        let QUERY = `
            mutation createUnitType ($manufacturerId: Int!, $name: String!, $database: String!, $typeSim: Boolean!, $active: Boolean!, $typeUseImei: Boolean) {
                result: createUnitType (manufacturerId: $manufacturerId, name: $name, database: $database, typeSim: $typeSim, active: $active, typeUseImei: $typeUseImei) {
                    id
                    name
                    active
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(unitTypeCreateResult(data?.result))
        } else {
            yield put(unitTypeCreateResult({ error: 'error-unit-type' }))
        }


    } catch (exc) {
        yield put(unitTypeCreateResult({ error: exc.error }))
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/unitTypesTab/.components/createEditUnitType/redux/saga",
            "createUnitType"
        )
    }
}

function* updateUnitType({ payload }) {
    try {

        let QUERY = `
            mutation updateUnitType ($id: String!, $name: String!, $typeSim: Boolean, $active: Boolean, $typeUseImei: Boolean) {
                result: updateUnitType (id: $id, name: $name, typeSim: $typeSim, active: $active, typeUseImei: $typeUseImei) {
                    id
                    name
                    active
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        if (data?.result) {
            yield put(unitTypeUpdateResult(data?.result))
        } else {
            yield put(unitTypeUpdateResult({ error: 'error-unit-type' }))
        }


    } catch (exc) {
        yield put(unitTypeUpdateResult({ error: exc.error }))
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/unitTypesTab/.components/createEditUnitType/redux/saga",
            "updateUnitType"
        )
    }
}

function* getUnitType({ payload }) {
    try {
        let QUERY = `
            query getUnitType ($id: Int!) {
                result: getUnitType (id: $id) {
                    id
                    name
                    manufacturerId
                    dbSchema
                    typeSim
                    typeUseImei
                    active
                }
            }
        `;


        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(unitTypeGetResult(data?.result));

    } catch (exc) {
        yield put(unitTypeGetResult());
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/unitTypesTab/.components/createEditUnitType/redux/saga",
            "getUnitType"
        )
    }
}

function* watchMethods() {
    yield takeEvery(UNITTYPES_CREATE_REQUEST, createUnitType);
    yield takeEvery(UNITTYPES_UPDATE_REQUEST, updateUnitType);
    yield takeEvery(UNITTYPES_GET_REQUEST, getUnitType);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}